import { render } from "./UserBalance.vue?vue&type=template&id=cdaf283e"
import script from "./UserBalance.vue?vue&type=script&lang=js"
export * from "./UserBalance.vue?vue&type=script&lang=js"

import "./UserBalance.vue?vue&type=style&index=0&id=cdaf283e&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__